import { Point } from "tm-shared/types";
import { isPointChains, isPointDistribution } from "tm-shared/utils";

export const pointToCopy = (point: Point) => {
    const { id, title, hasDebt, hasDebtCritical, type, market } = point;
    const additionalFields: Record<string, string> = {};

    if (isPointDistribution(point)) {
        additionalFields.externalMarketId = point.typeContext.externalId;
        additionalFields.storage = point.typeContext.storage.name;
        additionalFields.client = point.typeContext.client.name;
    }

    if (isPointChains(point)) {
        additionalFields.networkId = point.typeContext.networkId;
    }

    return {
        id,
        title: title,
        address: market.building.address.name,
        partner: market.contragent.name,
        type,
        contragent: market.contragent,
        hasDebt,
        hasDebtCritical,

        ...additionalFields,
    };
};
